function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.875 3.5C6.08211 3.5 6.25 3.66789 6.25 3.875V6.1L8.17094 7.25256C8.35207 7.36124 8.40959 7.59692 8.29888 7.77683C8.18904 7.95531 7.95531 8.01096 7.77683 7.90112L5.5 6.5V3.875C5.5 3.66789 5.66789 3.5 5.875 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6C1 3.25 3.25 1 6 1C8.75 1 11 3.25 11 6C11 8.75 8.75 11 6 11C3.25 11 1 8.75 1 6ZM2 6C2 8.2 3.8 10 6 10C8.2 10 10 8.2 10 6C10 3.8 8.2 2 6 2C3.8 2 2 3.8 2 6Z"
  }));
};

export default SvgComponent;